import React, { useContext } from "react";
import { Modal } from "@clarkinc/zest-design-system";
import { SectionGroupItem } from "./Filters";
import FastAnchor from "~/common/FastAnchor";
import { FilterModalContext } from "../FilterModalContextProvider";
interface Props {
  readonly groupItem: SectionGroupItem;
  prefetch?: boolean;
}
const CategoryFilterItem = ({
  groupItem,
  prefetch
}: Props) => {
  const {
    compareProductsActive,
    storedFilterUrl
  } = useContext(FilterModalContext);
  const shouldOpenModal = compareProductsActive && storedFilterUrl;
  const openModal = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    Modal.open("confirm-edit-filters-warning");
    // eslint-disable-next-line no-param-reassign
    storedFilterUrl.current.url = groupItem.filterUrl;
  };
  return <FastAnchor data-testid={`category-filter-item-checkbox-${groupItem.label}`} id={`${groupItem.filterUrl}`} prefetch={Boolean(prefetch)} wait={200} className="focus:outline-offset-[-3px] z-10" {...shouldOpenModal ? {
    href: "#",
    onClick: openModal,
    "aria-haspopup": "dialog"
  } : {
    href: groupItem.filterUrl,
    onClick: undefined
  }} data-sentry-element="FastAnchor" data-sentry-component="CategoryFilterItem" data-sentry-source-file="CategoryFilterItem.tsx">
      <div className="filter-list__item ">
        {groupItem.isSelected && <div className="wss-checkbox clearfix">
            <input type="checkbox" defaultChecked />
            <div className="list-check" />
          </div>}
        <span className="filter-list__content text-gray-800">
          {groupItem.label}
        </span>
      </div>
    </FastAnchor>;
};
export default CategoryFilterItem;